import { shallowEqual, useSelector } from 'react-redux';
import _ from 'lodash';
import { ROLE } from 'app/pages/settings/Team';

export const useApiData = (key = '', defaultValue = null) => {
  return useSelector(
    (state) => _.get(state, key, defaultValue),
    shallowEqual
  );
};

export const sortTags = (tags) => {
  if (!tags) return [];
  const pinLabels = tags?.filter((tag) => {
    return tag.pin;
  });
  const noPinLabels = tags?.filter((tag) => {
    return !tag.pin;
  });
  return [...pinLabels, ...noPinLabels]
}

function isRole(parentUsers, role) {
  const parentUserId = localStorage.getItem('x-parent-user-id')
  const userRole = parentUsers?.find((user) => user.parentUserId === parentUserId)?.role
  return userRole?.toLowerCase() === role.toLowerCase()
}

export const isNotViewOnlyRole = (parentUsers) => {
  return !isRole(parentUsers, ROLE[2])
}

export const isMemberOnlyRole = (parentUsers) => {
  return !isRole(parentUsers, ROLE[1])
}

export const isTeamAdmin = (parentUsers) => {
  return isMemberOnlyRole(parentUsers) && isNotViewOnlyRole(parentUsers)
}
